import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Background from './Components/Backgrounds/Background';
import { ThemeContextProvider } from './Themes/ThemeContext';
import './HiddenScroll.css';

const queryClient = new QueryClient();

export default function Providers({ children }) {

    return (
        <ThemeContextProvider>
            <QueryClientProvider 
                client={queryClient}
            >
                <Background>
                    {children}
                </Background>
            </QueryClientProvider>
        </ThemeContextProvider>
    );
}